import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PropsWithPopup } from 'scbk-services';
import { DialogWrapper } from 'scbk-ui-web';
import DeviceAuthStep1Component from './components/DeviceAuthStep1Component';
import DeviceAuthStep2Component from './components/DeviceAuthStep2Component';
import DeviceAuthStep3Component from './components/DeviceAuthStep3Component';
import DeviceAuthStep4Component from './components/DeviceAuthStep4Component';
import { useDeviceAuthStore } from './stores/useDeviceAuthStore';

interface Props extends PropsWithPopup {
  onComplete: () => void;
}

const DeviceAuthComponent: React.FC<Props> = ({ isOpen, setOpen, onComplete }) => {
  const [step1Trigger, setStep1Trigger] = useState(0);
  const [step2Trigger, setStep2Trigger] = useState(0);
  const [step3Trigger, setStep3Trigger] = useState(0);
  const [step4Trigger, setStep4Trigger] = useState(0);

  const { step, clear } = useDeviceAuthStore();

  // 다국어 처리
  const { t } = useTranslation();

  useEffect(() => {
    clear();
  }, []);

  return (
    <DialogWrapper
      title={t('DeviceAuthComponent.001', '단말기 지정/해제')}
      open={isOpen}
      setOpen={setOpen}
      isFull={true}
      footer={
        step === 1
          ? [
              {
                title: t('DeviceAuthComponent.002', '단말기 지정'),
                type: 'primary',
                handler: () => {
                  setStep1Trigger((v) => v + 1);
                },
              },
            ]
          : step === 2
            ? [
                {
                  title: t('DeviceAuthComponent.003', '다음'),
                  type: 'primary',
                  handler: () => {
                    setStep2Trigger((v) => v + 1);
                  },
                },
              ]
            : step === 3
              ? [
                  {
                    title: t('DeviceAuthComponent.003', '다음'),
                    type: 'primary',
                    handler: () => {
                      setStep3Trigger((v) => v + 1);
                    },
                  },
                ]
              : step === 4
                ? [
                    {
                      title: t('DeviceAuthComponent.004', '전화요청'),
                      type: 'primary',
                      handler: () => {
                        setStep4Trigger((v) => v + 1);
                      },
                    },
                  ]
                : []
      }
    >
      {step === 1 && <DeviceAuthStep1Component trigger={step1Trigger} />}
      {step === 2 && <DeviceAuthStep2Component trigger={step2Trigger} />}
      {step === 3 && <DeviceAuthStep3Component trigger={step3Trigger} />}
      {step === 4 && <DeviceAuthStep4Component trigger={step4Trigger} onComplete={onComplete} />}
    </DialogWrapper>
  );
};

export default DeviceAuthComponent;
